/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { TenantContext } from '@jira/platform__tenant-context-types/src/tenant-context.tsx';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type BusinessCapacityEntryPointComponent = EntryPointComponent<
	{},
	{},
	{},
	{
		tenantContext: TenantContext;
	}
>;

export const businessCapacityEntryPoint: EntryPoint<
	BusinessCapacityEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<BusinessCapacityEntryPointComponent>(
		/* webpackChunkName: "async-business-capacity-people" */ './BusinessCapacityEntryPoint.tsx',
	),
	getPreloadProps: (entryPointRouteParams: EntryPointRouteParams) => {
		const { tenantContext } = entryPointRouteParams;

		return {
			queries: {},
			entryPoints: {},
			extraProps: {
				tenantContext,
			},
		};
	},
});
